import Utils from '../../modules/utils'

const shareProperties = (propertyIds, callbackFunc) => {
  const url = 'share_properties'
  Utils.post(url, {shareProperty: {propertyIds}}, callbackFunc)
}

export {shareProperties}
